<template>
    <div class="property-card" :class="`layout-${layout}`">
        <div class="property-card-media-bloc">
            <div class="property-card-media-banner-box">
                <img :src="currentImage" alt="Imagem principal" />
                <div class="property-card-media-badge-box">
                    <span class="property-card-media-badge">
                        {{ property.destaque ? 'Destaque' : 'Conforto +' }}
                    </span>
                </div>
            </div>
            <div class="property-card-media-preview-box">
                <VueSlickCarousel
                    ref="carousel"
                    class="property-card-media-preview-carrousel"
                    v-bind="slickOptions"
                    @afterChange="updateBanner"
                    :key="images.length"
                >
                    <div
                        v-for="(image, index) in images"
                        class="property-card-media-preview-item"
                        @click="changeImage(index)"
                        :key="index"
                    >
                        <img :src="image" />
                    </div>
                    <template #prevArrow="{ currentSlide, slideCount }">
                        <button class="slick-prev">
                        <img src="@/assets/img/triplea/property-search/arrow-left.svg" alt="Previous" />
                        </button>
                    </template>
                    <template #nextArrow="{ currentSlide, slideCount }">
                        <button class="slick-next">
                        <img src="@/assets/img/triplea/property-search/arrow-right.svg" alt="Next" />
                        </button>
                    </template>
                </VueSlickCarousel>
            </div>
        </div>
        <div class="property-card-content-bloc">
            <div class="property-card-content-top">
                <div class="property-card-content-top-bloc-1">
                    <h6><PlaceIcon />{{ property.endereco }}, {{ property.bairro }}, {{ property.cidade }}</h6>
                    <h5>{{ property.tipo }} - {{ area_info }}</h5>
                </div>
                <div class="property-card-content-top-bloc-2">
                    <button>
                        <ShareIcon />
                    </button>
                    <span>
                        ref. {{ property.referencia }}
                    </span>
                </div>
            </div>
            <hr />
            <div class="property-card-content-mid">
                <h4>R$ {{ current_price }}</h4>
                <!-- <h5>Cond. </h5> -->
                <div class="property-card-content-mid-infos-box">
                    <div v-if="property.area_total" class="property-card-content-mid-info-item" :title="`${property.area_total} m²`">
                        <RuleIcon />
                        <span>{{ property.area_total }} m²</span>
                    </div>
                    <div v-if="property.Quartos" class="property-card-content-mid-info-item" :title="`${ property.Quartos } Quarto(s)`">
                        <RoomIcon />
                        <span>{{ property.Quartos }} Quarto(s)</span>
                    </div>
                    <div v-if="property.garagem" class="property-card-content-mid-info-item" :title="`${ property.garagem } Vaga(s)`">
                        <CarIcon />
                        <span>{{ property.garagem }} Vaga(s)</span>
                    </div>
                    <div v-if="property.banheiro" class="property-card-content-mid-info-item" :title="`${ property.banheiro } Banheiro(s)`">
                        <ShowerIcon />
                        <span>{{ property.banheiro }} Banheiro(s)</span>
                    </div>
                </div>
            </div>
            <div class="property-card-content-bottom">
                <p v-if="layout === 'list'">{{ resume }}</p>
                <a :href="property_url">Agendar negócio <LinkIcon /></a>
            </div>
        </div>
    </div>    
</template>
<script>
    import "@/assets/scss/custom/triplea/components/_property_card.scss"
    import { Carousel, Slide } from "vue-carousel";
    import VueSlickCarousel from 'vue-slick-carousel'

    import PlaceIcon from "@/components/icons/PlaceIcon.vue"
    import ShareIcon from "@/components/icons/ShareIcon.vue"
    import RuleIcon from "@/components/icons/property-info/RuleIcon.vue"
    import ShowerIcon from "@/components/icons/property-info/ShowerIcon.vue"
    import RoomIcon from "@/components/icons/property-info/RoomIcon.vue"
    import CarIcon from "@/components/icons/property-info/CarIcon.vue"
    import LinkIcon from "@/components/icons/property-info/LinkIcon.vue"


    export default {
    components: {
        Carousel,
        Slide,
        VueSlickCarousel,
        PlaceIcon,
        ShareIcon,
        RuleIcon,
        ShowerIcon,
        CarIcon,
        RoomIcon,
        LinkIcon
    },
    props: {
        property: {
        type: Object,
        default() {
            return {}
        }
        },
        preview_images: {
            type: Number,
            default() {
                return 1
            }
        },
        layout: {
            type: String,
            default() {
                return 'grid'
            }
        }
    },
    computed: {

        areaTypes() {
            return ['Terreno', 'Sítio', 'Chácara', 'Área', 'Área Condominio Fechado'].indexOf(this.property.tipo) != -1 ? true : false
        },

        shortstayClass() {
            if (typeof this.property.nomeEvento != "undefined" && this.property.nomeEvento.indexOf('shortstay') != -1) {
                return ' shortstay-property'
            } else {
                return ''
            }
        },

        temporadaClass() {
            if (typeof this.property.nomeEvento != "undefined" && this.property.nomeEvento.indexOf('temporada') != -1) {
                return ' temporada-property'
            } else {
                return ''
            }
        },

        layoutClass() {
            return ` layout-${this.layout}`
        },

        property_url() {
            return this.get_property_url(this.property)
        },

        parking_info() {
            let parking = parseInt(this.property.garagem)
            if ( parking <= 1 ) {
                return `${parking} vaga`
            } else {
                return `${parking} vagas`
            }
        },

        bedrooms_info() {
            let bedrooms = parseInt(this.property.dormitorios)
            if ( bedrooms <= 1 ) {
                return `${bedrooms} quarto`
            } else {
                return `${bedrooms} quartos`
            }
        },

        area_info() {
            return this.areaTypes ? `${Math.trunc(this.property.areaterreno)} m²` : `${Math.trunc(this.property.area_total)} m²`
        },

        bathroom_info() {
            return `${Math.trunc(this.property.banheiro)}`
        },

        old_price() {
            if ( this.property.ValorAnterior && this.property.ValorAnterior > this.property.valor_considerado ) {
                return this.number_format(this.property.ValorAnterior, 2, ',', '.')
            }
            return null
        },

        current_price() {
            return this.number_format(this.property.valor_considerado, 2, ',', '.')
        },

        countdow() {
            let countdow = null

            if ( this.property.situacao.toLowerCase().indexOf('reservad') != -1 ) {
                return countdow
            }

            if ( 
                    parseInt(this.property.IsFeiraoApolar) == 1 && 
                    typeof this.property.FimPromocao != "undefined" && 
                    typeof this.property.FimPromocao ) {

                let today = new Date()
                let end = new Date(this.property.FimPromocao)
                let diff_time = Math.abs(end - today);
                let diff_days = Math.ceil(diff_time / (1000 * 60 * 60 * 24));

                return diff_days <= 1 ? `${diff_days} dia` : `${diff_days} dias`

            }

            return countdow
        },

        reserved() {
            return this.property.situacao.toLowerCase().indexOf('reservad') != -1
        },

        photos() {
            let usage_photos = [this.principal_photo]
            let photos = this.property.popup_fotos.Foto.map(f => f['URLArquivo'][0])
            photos = photos.filter(f => f != this.property.foto_principal)
            if (this.preview_images >  1) {
                usage_photos = usage_photos.concat(photos.slice(0, this.preview_images-1))
            }
            return usage_photos
        },

        principal_photo() {
            return this.property.foto_principal.indexOf('semfoto.jpg') != -1 ?  require("@/assets/img/no-photo.webp") : this.property.foto_principal
        },

        address_info() {
            let num = this.layout == 'grid' ? 30 : 100
            return this.property.endereco.length > num ? this.property.endereco.slice(0, num) + "..."  : this.property.endereco
        },

        resume() {
            let num = 150
            return this.property.descricao.length > num ? this.property.descricao.slice(0, num) + "..."  : this.property.descricao
        },

        property_title: function() {
        var title = ""

        if (Object.keys(this.property).length > 0) {
            title = `${this.property.tipo} ${this.property.finalidade} para ${(this.property.transacao == "Vendas" ? "Venda" : "Locação")} no ${this.property.bairro} em ${this.property.cidade}, ${this.area_info}`
        }

        return title
        }
    },
    data() {
        return {
            images: [
                require("@/assets/img/triplea/property-search/placeholder-gif.gif"),
                require("@/assets/img/triplea/property-search/placeholder-gif.gif"),
                require("@/assets/img/triplea/property-search/placeholder-gif.gif"),
                require("@/assets/img/triplea/property-search/placeholder-gif.gif"),
                require("@/assets/img/triplea/property-search/placeholder-gif.gif"),
            ],
            currentImage: require("@/assets/img/triplea/property-search/placeholder-gif.gif"),
            slickOptions: {
                slidesToShow: 3,
                slidesToScroll: 1,
                focusOnSelect: true,
                arrows: true,
                vertical: true,
                verticalSwiping: true,
            },
        };
    },
    methods: {
        openProperty() {
            if ( this.property.transacao == "Lancamento" ) {

                if ( typeof this.property['linksite'] != "undefined" && this.property['linksite'] ) {
                    window.open(this.property['linksite'], '_blank').focus()
                    return false
                }

                let slug = this.slugify(`${this.property.cidade}-${this.property.bairro}-${this.property.condominio}-${this.property.referencia}`)
                this.$router.push({
                    name: 'property-details',
                    params: {
                        city: this.slugify(this.property.cidade),
                        district: this.slugify(this.property.bairro),
                        slug: slug,
                    }
                })

            } else {

                let slug = this.slugify(`${this.property.transacao}-${this.property.finalidade}-${this.property.tipo}-${this.property.cidade}-${this.property.bairro}-${this.property.referencia}`)
                
                this.$router.push({
                    name: 'principal-property-details',
                    params: {
                        city: this.slugify(this.property.cidade),
                        district: this.slugify(this.property.bairro),
                        slug: slug,
                    }
                })


            }

        },
        slugify(text) {
        return text
            .toString()                           // Cast to string (optional)
            .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
            .toLowerCase()                  // Convert the string to lowercase letters
            .trim()                                  // Remove whitespace from both sides of a string (optional)
            .replace(/\s+/g, '-')            // Replace spaces with -
            .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
            .replace(/\-\-+/g, '-');        // Replace multiple - with single -
        },
        shareThis() {
            if (navigator.share) {
                navigator.share({
                    title: `${this.property_title} - Apolar Imóveis`,
                    url: this.property_url
                })
            }
        },
        contactProperty() {
            this.$emit('contactProperty', this.property);
        },
        updateBanner(index) {
            this.currentImage = this.photos[index];
        },
        changeImage(index) {
            this.$refs.carousel.goTo(index);
            this.updateBanner(index);
        },
        updateImages() {
            if (this.property.popup_fotos && this.property.popup_fotos.Foto) {
                this.images = this.photos;
                this.currentImage = this.photos[0];
            }
        },
    },
    mounted() {
        this.updateImages();
    },
};
</script>
